module.exports = __webpack_public_path__ + "img/simplest-rainierarms.a2752411.png";